import { create } from "zustand";
import { useEffect } from "react";

export interface PaletteCommand {
  id: string;
  section: string;
  label: string;
  hint?: string;
  keywords?: string;
  perform: () => void;
}

interface PaletteState {
  open: boolean;
  setOpen: (v: boolean) => void;
  toggle: () => void;
  contextCommands: PaletteCommand[];
  setContextCommands: (cmds: PaletteCommand[]) => void;
}

export const useCommandPalette = create<PaletteState>((set) => ({
  open: false,
  setOpen: (v) => set({ open: v }),
  toggle: () => set((s) => ({ open: !s.open })),
  contextCommands: [],
  setContextCommands: (cmds) => set({ contextCommands: cmds }),
}));

/** Register page-local commands (e.g. "New task") into ⌘K while mounted. */
export function usePaletteCommands(cmds: PaletteCommand[]) {
  const setContextCommands = useCommandPalette((s) => s.setContextCommands);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setContextCommands(cmds);
    return () => setContextCommands([]);
  }, [cmds, setContextCommands]);
}
